import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import {
  MoreVert as MoreVertIcon,
  Logout as LogoutIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import logo from "../assets/img/logo-white.png";
import colors from "../styles/colors";
import useAuth from "../hooks/useAuth";
import { useLogoutMutation } from "../store/authApi";
import { FiGrid, FiUsers, FiSettings, FiActivity } from "react-icons/fi";

const menu = [
  {
    name: "Dashboard",
    to: "/Dashboard",
    icon: <FiGrid className="w-6 h-6" />,
  },
  {
    name: "Bekleyen Kullanıcılar",
    to: "/Bekleyen-Kullanicilar",
    icon: <FiUsers className="w-6 h-6" />,
  },
  {
    name: "Kullanıcı Yönetimi",
    to: "/Kullanici-Yonetimi",
    icon: <FiSettings className="w-6 h-6" />,
  },
  {
    name: "Cihazlar",
    to: "/Cihazlar",
    icon: <FiActivity className="w-6 h-6" />,
  },
];

export default function Sidebar() {
  const { setAuth, auth } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Use the logout mutation hook
  const [logoutUser] = useLogoutMutation();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      // Call logout API if user is authenticated
      if (auth?.accessToken) {
        await logoutUser({ token: auth.accessToken });
      }
    } catch (error) {
      console.error("Logout API error:", error);
    } finally {
      // Always clear local auth state regardless of API call result
      setAuth(null);
      navigate("/");
      handleMenuClose();
    }
  };

  return (
    <aside
      style={{
        background: colors.backgroundLoginCard,
        boxShadow: "0 4px 24px 0 rgba(30,64,175,0.10)",
      }}
      className="fixed top-0 left-0 h-full w-64 flex flex-col py-8 px-4 z-30"
    >
      <div className="flex items-center gap-3 mb-10 px-2">
        <img
          src={logo}
          alt="Logo"
          style={{
            width: 180,
          }}
        />
      </div>
      <nav className="flex-1 flex flex-col gap-2">
        {menu.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-5 py-4 rounded-2xl font-medium text-base transition-colors duration-200 ` +
              (isActive
                ? "bg-[#2563eb] text-white shadow"
                : "text-white/90 hover:bg-[#1e40af]/20 hover:text-white")
            }
            style={({ isActive }) => ({
              background: isActive ? colors.primary : undefined,
              color: isActive ? colors.white : colors.white,
            })}
          >
            <span className="opacity-90">{item.icon}</span>
            {item.name}
          </NavLink>
        ))}
      </nav>
      <div className="mt-auto pt-8">
        <div
          style={{ background: colors.primary, color: colors.white }}
          className="flex items-center gap-3 rounded-lg px-3 py-2 relative"
        >
          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white font-bold">
            {auth?.user?.name?.charAt(0) || "A"}
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm">
              {auth?.user?.name || "Admin"}
            </div>
            <div className="text-white/70 text-xs">
              {auth?.user?.email || "admin@pupill.com"}
            </div>
          </div>
          <IconButton
            onClick={handleMenuClick}
            size="small"
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </div>

        {/* Kullanıcı Menüsü */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              mt: -1,
              minWidth: 180,
              borderRadius: 2,
              boxShadow: "0 8px 32px 0 rgba(60,72,100,0.20)",
            },
          }}
        >
          <MenuItem
            onClick={() => {
              handleMenuClose();
              navigate("/Profil");
            }}
          >
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Profil</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={handleLogout}
            sx={{
              color: "error.main",
              "&:hover": {
                backgroundColor: "error.light",
                color: "error.dark",
              },
            }}
          >
            <ListItemIcon>
              <LogoutIcon fontSize="small" sx={{ color: "error.main" }} />
            </ListItemIcon>
            <ListItemText>Çıkış Yap</ListItemText>
          </MenuItem>
        </Menu>
      </div>
    </aside>
  );
}
